import { render, staticRenderFns } from "./SalesWoList.vue?vue&type=template&id=45751596&"
import script from "./SalesWoList.vue?vue&type=script&lang=js&"
export * from "./SalesWoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports